import React from 'react'
import PropTypes from 'prop-types'

const BaselineToggle = ({ selected, changeHandler }) => (
  <div className="cmwf--baseline-select-group">
    <label htmlFor="cmwf--baseline-select">Values</label>
    {' '}
    <select
      id="cmwf--baseline-select"
      className="select__small"
      onChange={e => changeHandler(e.target.value === 'BASELINE')}
      defaultValue={(selected ? 'BASELINE' : 'CURRENT')}
    >
      <option
        value="CURRENT"
      >Current</option>
      <option
        value="BASELINE"
      >Baseline</option>
    </select>
  </div>
)

BaselineToggle.propTypes = {
  selected: PropTypes.bool.isRequired,
  changeHandler: PropTypes.func.isRequired,
}

export default BaselineToggle



// WEBPACK FOOTER //
// ./src/components/Visualizations/components/baseline-toggle.jsx